(() => {
    let activeTrapContainer = null;
    let lastFocusedBeforeTrap = null;

    const getFocusableElements = (container) => {
        const selectors = [
            'a[href]', 'button:not([disabled])', 'input:not([disabled])',
            'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])'
        ].join(', ');

        return Array.from(container.querySelectorAll(selectors)).filter(el => el.offsetParent !== null || getComputedStyle(el).display !== 'none');
    };

    const handleFocusTrap = (e) => {
        if (!activeTrapContainer) return;

        const isTab = e.key === 'Tab' || e.keyCode === 9;
        const isEsc = e.key === 'Escape' || e.keyCode === 27;

        if (isEsc) {
            const internalCloseBtn = activeTrapContainer.querySelector('[data-action="close"]');

            if (internalCloseBtn) {
                internalCloseBtn.click();
            } else {
                const containerId = activeTrapContainer.id;
                if (containerId) {
                    const externalToggleBtn = document.querySelector(`[data-target="${containerId}"]`);
                    if (externalToggleBtn && externalToggleBtn.classList.contains('active')) {
                        externalToggleBtn.click();
                    }
                }
            }
            return;
        }

        if (!isTab) return;

        const elements = getFocusableElements(activeTrapContainer);

        if (elements.length === 0) {
            e.preventDefault();
            return;
        }

        const firstElement = elements[0];
        const lastElement = elements[elements.length - 1];

        if (e.shiftKey) {
            if (document.activeElement === firstElement || !activeTrapContainer.contains(document.activeElement)) {
                e.preventDefault();
                lastElement.focus();
            }
        } else {
            if (document.activeElement === lastElement || !activeTrapContainer.contains(document.activeElement)) {
                e.preventDefault();
                firstElement.focus();
            }
        }
    };

    const globalTrapObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'aria-expanded') {
                const targetElement = mutation.target;

                if (targetElement.dataset.focusTrap !== 'true') return;

                const isExpanded = targetElement.getAttribute('aria-expanded') === 'true';

                if (isExpanded) {
                    activeTrapContainer = targetElement;
                    lastFocusedBeforeTrap = document.activeElement;
                    document.addEventListener('keydown', handleFocusTrap);

                    requestAnimationFrame(() => {
                        const elements = getFocusableElements(targetElement);
                        elements.length > 0 && elements[0].focus({ preventScroll: true });
                    });
                } else {
                    if (activeTrapContainer === targetElement) {
                        activeTrapContainer = null;
                        document.removeEventListener('keydown', handleFocusTrap);

                        if (lastFocusedBeforeTrap && document.body.contains(lastFocusedBeforeTrap)) {
                            lastFocusedBeforeTrap.focus();
                            lastFocusedBeforeTrap = null;
                        }
                    }
                }
            }
        });
    });

    globalTrapObserver.observe(document.body, { attributes: true, attributeFilter: ['aria-expanded'], subtree: true });
})();